<template>
  <v-container>
    <h1 class="text-center text-uppercase">VENDORS</h1>
    <v-row class="text-left">
      <v-col>
        <v-btn color="primary1" dark @click="newVen = true">NEW VENDOR</v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn icon @click="getVendors">
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="VENDORS"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.phone="{ item }">
        <p>{{ item.phone + (item.phone2 != null ? "/" + item.phone2 : "") }}</p>
      </template>
      <template v-slot:item.id="{ item }">
        <v-icon color="warning" class="mr-2" @click="editVendor(item)">mdi-pencil</v-icon>
        <v-icon color="error" @click="deleteVendor(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="newVen" persistent scrollable max-width="50%">
      <v-card>
        <v-container>
          <v-form ref="form">
            <v-text-field label="Name *" required :rules="[rules.counter]" v-model="newVenDet.name"></v-text-field>
            <v-row>
              <v-col>
                <v-text-field
                  label="Contact Number *"
                  required
                  :rules="[RULES.required, RULES.mobile]"
                  v-model="newVenDet.phone"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Alternative Contact Number"
                  required
                  v-model="newVenDet.phone2"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field v-model="newVenDet.gstin" label="GSTIN" :rules="[RULES.required]"></v-text-field>
            <v-textarea label="Address *" v-model="newVenDet.address" :rules="[RULES.address]"></v-textarea>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="newVen = false">Close</v-btn>
            </v-col>

            <v-col>
              <v-btn color="green" dark block @click="addNewVen">ADD</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editVen" scrollable persistent max-width="50%">
      <v-card>
        <v-container>
          <v-form ref="updateform">
            <v-text-field
              label="Name *"
              required
              :rules="[RULES.required]"
              v-model="editVenDet.name"
            ></v-text-field>
            <v-row>
              <v-col>
                <v-text-field
                  label="Contact Number *"
                  required
                  :rules="[RULES.required, RULES.mobile]"
                  v-model="editVenDet.phone"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Alternative Contact Number"
                  required
                  v-model="editVenDet.phone2"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field v-model="editVenDet.gstin" label="GSTIN" :rules="[RULES.required]"></v-text-field>
            <v-textarea label="Address *" v-model="editVenDet.address" :rules="[RULES.address]"></v-textarea>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="editVen = false">Close</v-btn>
            </v-col>

            <v-col>
              <v-btn color="green" dark block @click="editVenDetSub">UPDATE</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      search: "",
      newForm: true,
      newVen: false,
      editVen: false,
      headers: [
        {
          text: "Vendor Name",
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: "Phone",
          align: "start",
          sortable: false,
          value: "phone"
        },
        {
          text: "GSTIN",
          align: "start",
          sortable: false,
          value: "gstin"
        },
        {
          text: "Shop Address",
          align: "start",
          sortable: false,
          value: "address"
        },
        {
          text: "ACTIONS",
          align: "center",
          sortable: false,
          value: "id"
        }
      ],
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length >= 3 || "Atleast 3 Letters",
        mobile: value => {
          const phone = /^\d{10}$/;
          return phone.test(value) || "ONLY 10 NUMBERS";
        },
        address: value => value.length >= 5 || "Atleast 5 Letters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      newVenDet: {
        name: "",
        phone: "",
        phone2: "",
        gstin: "",
        address: ""
      },
      editVenDet: {
        name: "",
        phone: "",
        phone2: "",
        gstin: "",
        address: ""
      }
    };
  },
  created() {},
  computed: {
    ...mapGetters(["VENDORS", "RULES"])
  },
  methods: {
    ...mapActions([
      "GET_VENDORS",
      "NEW_VENDORS",
      "UPDATE_VENDORS",
      "DELETE_VENDORS"
    ]),
    getVendors() {
      this.$store.commit("SET_LOADING", true);
      this.GET_VENDORS().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    editVendor(item) {
      this.editVenDet = {
        name: item.name,
        phone: item.phone,
        phone2: item.phone2,
        gstin: item.gstin,
        address: item.address,
        id: item.id
      };
      this.editVen = true;
    },
    editVenDetSub() {
      this.$store.commit("SET_LOADING", true);
      if (this.$refs.updateform.validate() && this.editVenDet.id != "") {
        this.editVen = false;
        this.UPDATE_VENDORS(this.editVenDet).then(() => {
          this.editVenDet = {
            name: "",
            phone: "",
            phone2: "",
            gstin: "",
            address: "",
            id: ""
          };
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
    deleteVendor(item) {
      this.$store.commit("SET_LOADING", true);
      this.DELETE_VENDORS({ id: item.id }).then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    addNewVen() {
      if (this.$refs.form.validate()) {
        this.$store.commit("SET_LOADING", true);
        this.newVen = false;
        this.NEW_VENDORS(this.newVenDet).then(() => {
          this.newVenDet = {
            name: "",
            phone: "",
            phone2: "",
            gstin: "",
            address: ""
          };
          this.$store.commit("SET_LOADING", false);
        });
      }
    }
  }
};
</script>

<style></style>
